import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuProps } from "antd/es/menu";

import styles from "./Menu.module.scss";

type MenuItem = Required<MenuProps>["items"][number];

const getItem = (
  label: React.ReactNode,
  key: React.Key,
  icon?: IconProp,
  children?: MenuItem[]
): MenuItem => {
  return {
    children,
    className: styles.subTitle,
    "data-menu-category": children ? key : undefined,
    "data-menu-item": children ? undefined : key,
    icon: icon ? <FontAwesomeIcon className={styles.subtitleIcon} icon={icon} /> : undefined,
    key,
    label,
  } as MenuItem;
};

export default getItem;
